<template>
    <v-card class="main-card">
        <dropdown
                icon="fal fa-calendar"
                :label="'Period' | t"
                type="daterange"
                :value="filterDates"
                :format-emit="false"
                @select="updateFilter($event, 'periodRange')"
        />

        <template v-if="firstLoadingDone">
            <div>
                <v-row no-gutters>
                    <v-col cols="12" lg="6">
                        <RadioButton
                                :label="'Year/Month' | t"
                                :buttonValue="'year-month'"
                                v-model="groupByPeriodSync"
                        />
                    </v-col>
                    <v-col cols="12" lg="6">
                        <RadioButton :label="'Year/Week' | t" :buttonValue="'year-week'" v-model="groupByPeriodSync"/>
                    </v-col>
                </v-row>
            </div>

            <dropdown
                    :loading="calculatingFilterOptions || dataLoading"
                    :value="filters.categoryIds"
                    :items="categoryOptions"
                    item-text="text"
                    item-value="value"
                    icon="fal fa-layer-group"
                    :label="'Category' | t"
                    type="multiple"
                    @select="updateFilter($event, 'categoryIds')"
                    @remove="handleRemove($event,'categoryIds')"
            />

            <dropdown
                    :loading="calculatingFilterOptions || dataLoading"
                    :value="filters.brandIds"
                    :items="brandOptions"
                    item-text="text"
                    item-value="value"
                    icon="fal fa-tag"
                    :label="'Brand' | t"
                    type="multiple"
                    @select="updateFilter($event, 'brandIds')"
                    @remove="handleRemove($event,'brandIds')"
            />

            <dropdown
                    :loading="calculatingFilterOptions || dataLoading"
                    :value="filters.productCodes"
                    :items="productOptions"
                    item-text="text"
                    item-value="value"
                    icon="fal fa-hashtag"
                    :label="'Product name' | t"
                    type="multiple"
                    @select="updateFilter($event, 'productCodes')"
                    @remove="handleRemove($event,'productCodes')"
            />

            <dropdown
                    :loading="calculatingFilterOptions || dataLoading"
                    :value="filters.netoWeights"
                    :items="netoWeightOptions"
                    item-text="text"
                    item-value="value"
                    icon="fal fa-weight-hanging"
                    :label="'Neto weight' | t"
                    type="multiple"
                    @select="updateFilter($event, 'netoWeights')"
                    @remove="handleRemove($event,'netoWeights')"
            />

            <dropdown
                    :loading="calculatingFilterOptions || dataLoading"
                    :value="filters.countries"
                    :items="countryOptions"
                    item-text="text"
                    item-value="value"
                    icon="fal fa-globe"
                    :label="'Country' | t"
                    type="multiple"
                    @select="updateFilter($event, 'countries')"
                    @remove="handleRemove($event,'countries')"
            />

            <dropdown
                    :loading="calculatingFilterOptions || dataLoading"
                    :value="filters.clients"
                    :items="clientOptions"
                    item-text="text"
                    item-value="value"
                    icon="fal fa-copyright"
                    :label="'Client' | t"
                    type="multiple"
                    @select="updateFilter($event, 'clients')"
                    @remove="handleRemove($event,'clients')"
            />

            <dropdown
                    :loading="calculatingFilterOptions || dataLoading"
                    :value="filters.chains"
                    :items="chainOptions"
                    item-text="text"
                    item-value="value"
                    icon="fal fa-shopping-cart"
                    :label="'Chain' | t"
                    type="multiple"
                    @select="updateFilter($event, 'chains')"
                    @remove="handleRemove($event,'chains')"
            />

            <dropdown
                    :loading="calculatingFilterOptions || dataLoading"
                    :value="filters.shops"
                    :items="shopOptions"
                    item-text="text"
                    item-value="value"
                    icon="fal fa-map-marker-alt"
                    :label="'Shop' | t"
                    type="multiple"
                    @select="updateFilter($event, 'shops')"
                    @remove="handleRemove($event,'shops')"
            />

            <dropdown
                    :loading="calculatingFilterOptions || dataLoading"
                    :value="filters.shopTypes"
                    :items="shopTypeOptions"
                    item-text="text"
                    item-value="value"
                    icon="fal fa-store-alt"
                    :label="'Shop type' | t"
                    type="multiple"
                    @select="updateFilter($event, 'shopTypes')"
                    @remove="handleRemove($event,'shopTypes')"
            />

            <dropdown
                    :loading="calculatingFilterOptions || dataLoading"
                    :value="filters.infoProviders"
                    :items="infoProviderOptions"
                    item-text="text"
                    item-value="value"
                    icon="fal fa-info-circle"
                    :label="'Info provider' | t"
                    type="multiple"
                    @select="updateFilter($event, 'infoProviders')"
                    @remove="handleRemove($event,'infoProviders')"
            />

            <dropdown
                    :loading="calculatingFilterOptions || dataLoading"
                    :value="filters.salesmen"
                    :items="salesmanOptions"
                    item-text="text"
                    item-value="value"
                    icon="fal fa-user-tie"
                    :label="'Salesman' | t"
                    type="multiple"
                    @select="updateFilter($event, 'salesmen')"
                    @remove="handleRemove($event,'salesmen')"
            />

            <div class="button-group">
                <button :disabled="dataLoading" :class="{ active: filters.regions.includes('ee') }"
                        @click="handleRegionInput('ee')">
                    <i v-if="filters.regions.includes('ee')" class="far fa-check check-icon"></i>
                    {{ "EE" | t }}
                </button>
                <button :disabled="dataLoading" :class="{ active: filters.regions.includes('eu') }"
                        @click="handleRegionInput('eu')">
                    <i v-if="filters.regions.includes('eu')" class="far fa-check check-icon"></i>
                    {{ "EU" | t }}
                </button>
                <button :disabled="dataLoading" :class="{ active: filters.regions.includes('noneu') }"
                        @click="handleRegionInput('noneu')">
                    <i v-if="filters.regions.includes('noneu')" class="far fa-check check-icon"></i>
                    {{ "NON EU" | t }}
                </button>
            </div>

            <button
                class="filter-options-btn"
                @click="handleFilterOptions"
                :disabled="dataLoading"
                :class="{ loading: dataLoading, disabled: dataLoading }"
            >
                <i v-if="dataLoading" class="fal fa-spinner-third fa-spin loader-icon"></i>
                <span v-else>
                    <i class="fal fa-filter"></i>
                    {{ "Filter dropdown options" | t }}
                </span>
            </button>
        </template>

        <div class="action-bar">
            <span class="reset-text" :class="{ disabled: dataLoading }" @click="resetFilters">
                {{ "Reset" | t }}
            </span>

            <button
                    class="apply-btn"
                    @click="handleApplyFilters"
                    :disabled="dataLoading"
                    :class="{ loading: dataLoading, disabled: dataLoading }"
            >
                <i v-if="dataLoading" class="fal fa-spinner-third fa-spin loader-icon"></i>
                <span v-else> {{ "Apply" | t }} </span>
            </button>
        </div>
    </v-card>
</template>
<script>
import { mapMutations, mapState, mapActions, mapGetters } from "vuex";
import DatePicker from "v-calendar/lib/components/date-picker.umd";
import DateRangeInput from "@/components/input/date-range-input.vue";
import RadioButton from "@/components/input/radio-button.vue";
import Dropdown from "@/components/dropdown/dropdown.vue";

export default {
    name: "analysis-filters-card",
    components: {
        Dropdown,
        DateRangeInput,
        DatePicker,
        RadioButton,
    },
    data() {
        return {
            autoUpdateDebounce: null,
        };
    },
    async mounted() {
        const now = new Date();
        const initDates = {
            start: new Date(now.getFullYear(), 0, 1),
            end: now,
        };
        this.updateFilter(initDates, "periodRange");
    },
    methods: {
        ...mapActions("AnalysisStore", ["fetchData", "generateChartData", "generateClientTableData", "generateProductTableData"]),
        ...mapMutations("AnalysisStore", [
            "updateFilters",
            "setFilterDates",
            "setGroupByPeriod",
            "resetFilters",
            "setDatesChanged",
            "setFilterOptionsEnabled",
        ]),
        handleRegionInput(region) {
            const updatedRegions = [...this.filters.regions];
            if (updatedRegions.includes(region)) {
                updatedRegions.splice(updatedRegions.indexOf(region), 1);
            } else {
                updatedRegions.push(region);
            }
            this.updateFilter(updatedRegions, "regions");
        },
        updateFilter(value, filter) {
            if (filter === "periodRange") {
                this.setFilterDates(value);
                this.setDatesChanged(true);
                return;
            }
            if (filter === "groupByPeriod") {
                this.setGroupByPeriod(value);
                return;
            }

            this.updateFilters({ filter, value });
        },
        handleRemove(value, field) {
            const current = this.filters[field] || [];
            const updated = current.filter((v) => v !== value);
            this.updateFilters({ filter: field, value: updated });
        },
        async handleApplyFilters() {
            if (this.datesChanged) {
                await this.fetchData()
            }
            this.generateChartData()
            this.generateClientTableData()
            this.generateProductTableData()
        },
        handleFilterOptions() {
            // Enable filtering
            this.setFilterOptionsEnabled(true);

            // Recalculate with filtering - this will show which options match current filters
            this.$store.dispatch('AnalysisStore/calculateSalesOptions');
        }
    },
    computed: {
        ...mapState("AnalysisStore", [
            "filters",
            "dataLoading",
            "datesChanged",
            "firstLoadingDone",
            "filterDates",
            "groupByPeriod",
            "calculatingFilterOptions",
        ]),
        ...mapGetters("AnalysisStore", [
            "netoWeightOptions",
            "categoryOptions",
            "brandOptions",
            "countryOptions",
            "clientOptions",
            "chainOptions",
            "shopOptions",
            "salesmanOptions",
            "productOptions",
            "infoProviderOptions",
            "shopTypeOptions"
        ]),
        groupByPeriodSync: {
            get() {
                return this.groupByPeriod;
            },
            set(value) {
                this.updateFilter(value, "groupByPeriod");
            },
        },
    },
    watch: {
        filters: {
            handler(newFilters, oldFilters) {
                if (!oldFilters) return;

                if (this.datesChanged) return;

                if (this.autoUpdateDebounce) {
                    clearTimeout(this.autoUpdateDebounce);
                }

                this.autoUpdateDebounce = setTimeout(() => {
                    this.generateChartData();
                    this.generateClientTableData();
                    this.generateProductTableData();
                }, 500);
            },
            deep: true,
        },
        groupByPeriod(newVal, oldVal) {
            if (!oldVal) return;

            if (this.datesChanged) return;

            this.generateChartData();
            this.generateClientTableData();
            this.generateProductTableData();
        },
        filterDates(newVal, oldVal) {
            if (!oldVal || !oldVal.start) return;

            if (this.autoUpdateDebounce) {
                clearTimeout(this.autoUpdateDebounce);
            }

            this.autoUpdateDebounce = setTimeout(async () => {
                await this.fetchData();
                this.generateChartData();
                this.generateClientTableData();
                this.generateProductTableData();
            }, 1000);
        },
    },
    beforeDestroy() {
        if (this.autoUpdateDebounce) {
            clearTimeout(this.autoUpdateDebounce);
        }
    },
};
</script>
<style scoped>
.button-group {
    width: 100%;
    height: 45px;
    display: flex;
    justify-content: center;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    padding: 4px;
    gap: 12px;
    box-sizing: border-box;
}

.button-group button {
    flex: 1;
    height: 100%;
    background-color: white;
    border: none;
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
    transition: background-color 0.2s ease;
    color: black;
    line-height: 1;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
}

.button-group button.active {
    background-color: rgba(244, 193, 198, 1);
}

.button-group button:hover {
    background-color: #f5f5f5;
}

.button-group button .check-icon {
    font-size: 12px;
    color: #f41823;
}

.action-bar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 44px;
}

.reset-text {
    color: #f41823;
    text-decoration: underline;
    font-family: Inter, sans-serif;
    font-weight: 600;
    font-size: 13px;
    line-height: 13px;
    cursor: pointer;
}

.apply-btn {
    background-color: #f41823;
    color: white;
    height: 100%;
    border-radius: 8px;
    padding: 7px 16px;
    font-family: Inter, sans-serif;
    font-weight: 600;
    font-size: 13px;
    line-height: 13px;
    cursor: pointer;
    border: none;
    min-width: 68px;
}

.apply-btn.disabled {
    background-color: rgba(100, 100, 100, 1);
    cursor: default;
}

.reset-text.disabled {
    color: gray;
    cursor: default;
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}

.loader-icon {
    color: white;
    font-size: 20px;
    animation: spin 1s linear infinite;
}

.main-card {
    height: 100%;
    padding: 24px;
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.filter-options-btn {
    width: 100%;
    height: 45px;
    background-color: #777777;
    color: white;
    border: none;
    border-radius: 8px;
    font-family: Inter, sans-serif;
    font-weight: 600;
    font-size: 13px;
    cursor: pointer;
    transition: background-color 0.2s ease;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
}

.filter-options-btn:hover:not(.disabled) {
    background-color: #005f8f;
}

.filter-options-btn.disabled {
    background-color: rgba(100, 100, 100, 1);
    cursor: not-allowed;
}

.filter-options-btn i {
    font-size: 14px;
}
</style>
